import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.is-array";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.reduce";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.date.to-string";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.match";
import "core-js/modules/es.string.replace";
import "core-js/modules/es.string.search";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";
import "core-js/modules/web.timers";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/*
 Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.

 Author: Thomas Barry

 Description:
 */

/* eslint-disable wf-security/no-location-href */
import globals from '../globals/globals';
import postForm from '../network/post-form';
import { getStore } from '../../lib/store/store';
import { logToConsole } from '../../lib/store/console/actions';
var NONE = 'NONE';
var DEBUG = 'DEBUG';
var INFO = 'INFO';
var WARN = 'WARN';
var ERROR = 'ERROR';
var levels = [DEBUG, INFO, WARN, ERROR, NONE];

var parseErrorStack = function parseErrorStack(_stack) {
  var isChrome = _stack.search(/\n+ +at/) !== -1;
  var result = [];

  var stack = _stack.replace(/(\d+):\d+\)\n/g, '$1\n');

  var lines = stack.split(/\n(?: +at )?/);

  if (isChrome) {
    lines.shift();
  }

  lines.forEach(function (_line) {
    var item = {};
    var funcName;

    if (isChrome) {
      funcName = _line.split(/ /).shift();
    } else {
      funcName = _line.split(/@/).shift();
    }

    var match = funcName.match(/\((.*)\)$/);

    if (match) {
      item.args = match[1];
      funcName = funcName.substr(0, funcName.indexOf('('));
    }

    item.name = funcName;
    item.line = _line.split(/:/).pop();

    var line = _line.replace(/:\d+$/, '');

    item.url = line.split(/[(@]/).pop();
    result.push(item);
  });
  return result;
};

var logMessage = function logMessage(level) {
  var currentLevel = levels.indexOf((globals().logLevel || ERROR).toUpperCase());
  var currentConsoleLevel = levels.indexOf((globals().logLevelConsole || ERROR).toUpperCase());
  var parts = [];
  var messageObj = undefined;

  for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    params[_key - 1] = arguments[_key];
  }

  var result = params.reduce(function (parts, part) {
    if (part && part.message) {
      parts.push(part.message);

      if (part.stack) {
        var stack = parseErrorStack(part.stack);
        messageObj = {};

        if (stack[0] && stack[0].name) {
          messageObj.errorFunctionName = stack[0].name;
        }

        if (stack[0] && stack[0].line) {
          messageObj.errorLineNumber = stack[0].line;
        }

        if (stack[0] && stack[0].url) {
          messageObj.jsFileUrl = stack[0].url;
        }

        if (stack[0] && stack[0].args) {
          messageObj.additionalInfo = 'arguments: ' + stack[0].args;
        }

        if (stack[1] && stack[1].name) {
          messageObj.callingFunctionName = stack[1].name;
        }
      }
    } else {
      parts.push(part || 'undefined');
    }

    return parts;
  }, parts);

  if (currentConsoleLevel <= levels.indexOf(level)) {
    if (window.console) {
      var _console;

      // eslint-disable-next-line
      (_console = console).log.apply(_console, [level].concat(_toConsumableArray(result)));
    }

    setTimeout(function () {
      return getStore().dispatch(logToConsole(level, _toConsumableArray(result)));
    }, 10);
  }

  if (currentLevel <= levels.indexOf(level)) {
    var data = {
      messageLevel: level,
      url: window.location.href,
      F: 'J',
      message: parts.join(' ')
    };

    if (messageObj) {
      data = Object.assign(data, messageObj);
    }

    globals().loggingUrl && postForm({
      url: globals().loggingUrl,
      data: data
    });
  }
};

window.addEventListener('error', function (_ref) {
  var error = _ref.error,
      message = _ref.message;
  logMessage(ERROR, error, message);
  return false;
});
export default {
  debug: function debug() {
    for (var _len2 = arguments.length, params = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      params[_key2] = arguments[_key2];
    }

    return logMessage.apply(void 0, [DEBUG].concat(params));
  },
  info: function info() {
    for (var _len3 = arguments.length, params = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      params[_key3] = arguments[_key3];
    }

    return logMessage.apply(void 0, [INFO].concat(params));
  },
  warn: function warn() {
    for (var _len4 = arguments.length, params = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      params[_key4] = arguments[_key4];
    }

    return logMessage.apply(void 0, [WARN].concat(params));
  },
  error: function error() {
    for (var _len5 = arguments.length, params = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      params[_key5] = arguments[_key5];
    }

    return logMessage.apply(void 0, [ERROR].concat(params));
  }
};
export { parseErrorStack };